export const service_property_management = {
  title: "PROPERTY MANAGEMENT",
  sub_title: "Let us help you get more from your investment",
  para1:
    "Primus Agents understands the importance of extracting the most value from your investment properties. Unlike most real estate brands, our management professionals are not working for a wage, they own the rent rolls they manage. This means the value you receive for your investment asset directly effects the value the Primus management professional receives. In other words our interests are directly aligned with yours!",
  para2: "Contact primus agents today to discuss management options!",
};

export const service_commercial = {
  title: "COMMERCIAL",
  sub_title: "Let us help you find or sell your commercial space",
  para1:
    "For your business to succeed, you need to be in the right place at the right time. That’s where we come in. Talk to our primus experts today about our commercial property for sales and commercial property for lease today.​",
  para2:
    "Our national network of experienced agents, Primus Commercial conducts meticulous analysis and provides trusted advice to business owners nationally. Using our customized software and support, our agents provide comprehensive options and marketing catered for you. With proven track records Primus Commercial agents makes it their business to develop an understanding of yours.",
};

export const service_insurance = {
  title: "Primus Insurance",
  sub_title: "Your Trust, Our Responsibility",
  para1:
    "Primus Agents is a trusted and forward-thinking company committed to delivering reliable solutions for all your property needs. We place the highest priority on customer satisfaction and safety.",
  para2:
    "At Primus, we believe that an insurance plan is more than just a service—it’s a safeguard for your dreams and a foundation for your peace of mind. With us, you’re not just protected—you’re empowered to build your future with confidence.",
  tab_item_1: "Home Insurance",
  tab_item_2: "Car Insurance",
  tab_item_3: "Landlords Insurance",
  tab_item_4: "Health & Sickness Insurance",
  tab_item_5: "Business Pack Insurance",
  tab_item_6: "Public Liability Insurance",
  tab_item_7: "Cyber Insurance",
  tab_item_8: "Professional Indemnity Insurance",
  home: {
    overview: [
      "Home and Contents Insurance can protect you against the cost of damages to your home and possessions after an insurable event.",
      "Your home is not just a physical asset but something much more to you. Fires, earthquakes, lightning, malicious damage, weather conditions- we do not want our house to be the receiving end of these events. But if that happens, Home and Contents Insurance can help you cover the repair costs or rebuild your property. It can also cover the cost of replacing some of the possessions.",
      "We aim to provide quality insurance that can give you extra security and peace of mind.",
    ],

    title: "What is Home and Contents Insurance?",
    description:
      "Primus Agents is a policy that covers both your property and the belongings that make it a home by combining the advantages of Home Building Insurance and Contents Insurance. Select from three distinct coverage tiers, each protecting your house and belongings against theft, storm damage, fire damage, and other hazards.",
    covered_title: "What’s covered.",
    covered: [
      "Protection from floods, storms, storm surges, fire (including bushfires), and break-ins",
      "Cover for contents in commercial storage or in transit",
      "Flexible limits for high value items",
    ],
    not_covered_title: "What’s not covered.",
    not_covered: [
      "Any new buildings during construction",
      "Cash, phone cards, smart cards, tradeable documents, money orders, tickets, vouchers, and stamps (not in a set or collection) are examples of acceptable payment methods",
      "Anything electronic or electrical that can’t be used for what it was made for.",
      "Temporary or movable structures, such as campers, houseboats, boats, or any kind of motorized vehicle or craft When something goes wrong, your house and possessions are covered by your home and contents insurance",
      "Consider your needs and what is (and isn’t) covered by various policies before purchasing insurance",
      "Obtain the appropriate coverage to prevent underinsurance",
      "Determine the value of your possessions and the cost of restoring your home with accuracy",
      "Recognize the distinction between sum-insured and total replacement coverage when purchasing house insurance",
      "Make sure your contents insurance covers the replacement value of your belongings (‘new for old’)",
      "Examine the exclusions to see what isn’t included",
      "Check the maximum claim limits",
      "Verify whether your moveable structure is covered while you’re away from home by your contents insurance",
      "Verify your coverage for storms, floods, and fires if you reside in a disaster-prone location",
    ],
  },
  car: {
    overview: [
      "Car insurance covers your financial loss if your car is involved in an accident. There are three main aspects of car insurance: comprehensive car insurance, third-party insurance, and compulsory third-party insurance.",
      "A comprehensive car insurance policy covers fixing your car damage caused by events like crashes, fires, robberies, and weather conditions. It also covers third-party vehicle damage caused by your car in such events.",
      "Third-party car insurance provides cover for damage caused by your car to someone else’s vehicle or property.",
      "Compulsory Third Party insurance (known as a Green Slip in NSW) covers the cost of third-party compensation if your car causes an accident in which someone else is injured.",
      "Third parties who could ask for compensation include your co-passengers and other road users such as passersby, motorcyclists, cyclists, and any other drivers and passengers. ",
    ],
    insurance_types: {
      description:
        "Comprehensive Car Insurance: Provides coverage for vehicle loss or damage from accidents, theft, bad weather, vandalism, and fire, as well as your liability for accidental property damage that your vehicle may cause to other people.",
      covers: [
        "Damage to someone else's car",
        "Damage to your own car",
        "Car hire after non-fault theft/accident",
        "New car replacement",
      ],
    },
    third_party_types: {
      description:
        "Third Party Property, Fire and Theft: It covers you against liability for accidental damage your car causes to other people’s property, as well as loss or damage your car suffers from theft and fire.",
      covers: [
        "Damage to someone else's car",
        "Damage to your car (fire & theft only)",
        "Car hire after theft",
      ],
    },
    third_party_types2: {
      description:
        "Third Party Property Only: It covers you against liability for accidental damage your car does to other people’s belongings, including their cars.",
      covers: ["Damage to someone else's car"],
    },

    benefits_features: {
      description:"Benefits and features",
      covers:[
      "Tailor-made cover",
      "Lifetime guarantees on authorised repairs",
      "New car replacement option",
      "24/7 claims service",
      "Outstanding value",
      "Highly rated claims process",
      "Towing costs coverage",
      "Hire car after no-fault accident/theft",
    ],
  }
  },
  landlords: {
    overview: [
      "Landlord Insurance is a type of home insurance policy that covers homeowners from financial losses that might incur with rental properties.",
      "It is designed to cover the cost of replacement or repairs when certain events occur, like fire and allied perils, theft, and malicious damage that harms your residential investment property.",
      "The content you provide for your tenants can also be covered.",
      "It covers Accidental damage and Defined events for your property.",
    ],
    title1: "What our Landlord Insurance covers",
    items1: [
      "Buildings (Investment property)",
      "Content",
      "Third-party Legal Liability",
    ],
    title2: "What’s included, For your rental property",
    items2: [
      "Tenant stops paying rent: We compensate the lost rent in the event that your tenant quits without providing you notice or stops paying rent.",
      "Lost rent during repairs: We will compensate for lost rent if a covered incident renders your building unlivable.",
      "Theft & vandalism: We cover stolen items and damage from theft and vandalism.",
      "Fire: We provide coverage for fire-related losses and damage, including bushfires.",
      "Flood, rainwater run-off & storm surge cover: We insure against loss or damage caused by storm surge, rainwater runoff, and flooding.",
      "Furniture & furnishings: We insure against theft or damage to carpets, furniture, and other furnishings on your premises.",
      "Water & oil leaks: We cover damage to your property and items caused by water and oil leaks, like from a burst pipe or broken heater.",
      "Broken glass: We cover various pieces of furniture or equipment that may have accidentally shattered ceramics or glass.",
      "Impact damage: Damage that occurs from objects like cars and trees is covered by our insurance.",
      "Lightning: We cover damage and power surges caused by lightning.",
      "Demolishing & removing debris: If your building’s covered and it’s damaged after a covered event, we pay to demolish and remove debris.",
      "Motor burnout: We cover labour and parts for electric motor fusion.",
      "Renovation building materials: We cover damage from covered events to the renovation materials at your rental property if your property is covered.",
      "Liability for injury or damage: In some circumstances, we will cover your legal liability if someone gets injured or their property is damaged.",
    ],
  },
  health_sickness: {
    title: "Overview:",
    overview: [
      "Our Individual Personal Accident clients can be found in all walks of life – from journalists and aid workers overseas, to self-employed tradies and long-distance truck drivers, Gravitas has the flexibility and top-notch security to keep you safe while working.",
      "Our Individual Personal Accident Insurance is intended to give anyone, including sole proprietors, peace of mind in the event that they become ill or are injured within the parameters of the policy.",
      "Our coverage offers a lump sum payment in the event of an accidental death or permanent total disability, or it replaces weekly income in the event of a temporary disability to work.",
      "With over 25 extra advantages, a choice of coverage options (24/7, Working Hours Only, and Outside Working Hours Only), and the flexibility to select the benefits and sums covered, our coverage may be customized to match the unique needs of individuals and/or single traders.",
      "Our coverage comes with a standard list of benefits, but it may also be further customized to fulfill the unique needs of the business, the employees, or the members by choosing from the list of optional benefits.",
    ],
  },
  business_pack: {
    overview: [
      "A business insurance pack provides cover for your business premises and contents, against loss, damage or theft as well as cover against any resulting financial loss from an insured interruption to the business.",
      "The type of business insurance and the amount of cover you select will depend on the nature of your business and what areas you think are the riskiest for you. Pick and choose the right business insurance that will suit you the best.",
    ],
    title: "What is typically covered by Business Insurance?",
    items: [
      "Material damage loss for your physical assets",
      "Financial loss due to Business Interruption",
    ],
    title1: "What is typically not covered by Business Insurance?",
    items1: [
      "Negligence/breach of duty arising from an act, error, or omission because of your professional services.",
      "Standard policies typically do not cover flood damage.",
      "Known claims and circumstances.",
    ],
    title2: "Industries that may require Business Insurance",
    items2: [
      "Small businesses in Australia, including personal trainers, IT specialists, coffee shop proprietors, cleaners, and reliable tradespeople, all contribute to the country’s economy.",
      "Running your own business always involves some risk, even though your daily operations may differ from others’. This is a brief overview of some common business types that can need business insurance.",
    ],
    items2_button: [
      "Accountants",
      "Finance & Mortgage Brokers",
      "Restaurants",
      "IT Professionals",
      "Cleaners",
      "Car Wash",
      "Auto Dealers",
      "Hair & Beauty Services",
      "Real Estate Agents",
      "Trade Business",
    ],
    title3: "Get the right type of Business Insurance",
    items3: [
      "Even though your company is seen as “small,” it matters a lot to you and us. We want to make sure you have the appropriate protection because of this.",
      "We provide a range of coverage options that suit different business needs.",
    ],
    title4:
      "Certain kinds of businesses might need business insurance, such as:",
    items4: [
      "It could be necessary for you to obtain your own public liability insurance before visiting a construction site.",
      "You might need to carry a certain amount of professional indemnity insurance if you work on contracts.",
      "If you are renting a space for your business, your landlord can insist that you obtain your own glass coverage and public liability insurance.",
    ],
  },
  public_liability: {
    overview_title: "What kind of businesses need Public Liability insurance?",
    overview: [
      "In short, public liability insurance may be necessary if your business often interacts with third parties, such as clients, suppliers, and members of the public.",
      "It can be difficult to forecast when a public liability insurance claim will arise, but if it does, the expenses to your business might be severe and could even force you out of business.",
    ],
    title:
      "Typical business types that might purchase a public liability insurance policy include the following:",
    items: [
      "Trades",
      "Professionals",
      "Wholesalers",
      "Manufacturers",
      "Travel and tourism",
      "Office based",
    ],
    title1: "What is typically included?**",
    sub_title: "Compensation for:",
    items1: [
      "Expenses related to compensating a third party for personal injury (e.g., a client, supplier, or member of the public)",
      "Compensation for reimbursement for third-party property damage resulting from your careless business activities.",
      "The expenses of defence and legal representatives for a covered claim",
      "Compensation for any harm to property belonging to third parties that you are in charge of, care for, or control",
    ],
    sub_title1:
      "** Product liability is covered by many public liability policies as well.",
    title2: "What is typically not covered?*",
    items2_button: [
      "Injuries to your employees",
      "Damage to your own property",
      "Expenses to repair defective workmanship or a product recall",
      "Professional negligence",
      "Contractual liability",
      "Events that happen either before or after the policy period",
      "Aircraft products",
      "Asbestos",
      "Liquidated damages",
      "Gradual pollution",
      "Punitive damages (due to reckless or intentional misconduct)",
      "Liabilities assumed under contract beyond common law obligations",
    ],
    title3: "Do I need Product Liability Insurance?",
    items3: [
      "Product distribution and supply businesses operating in Australia should give careful thought to purchasing product liability insurance. It is always possible for something to go wrong, even with the highest attention to safety.",
      "A product defect can lead to costly claims for property damage or personal injury, and if you don’t have the right product liability insurance, you could find yourself in hot water. A product liability claim could have a significant impact on your personal assets if you are a sole trader, since you may be held personally liable for allegations of property damage or personal harm.",
    ],
    title4: "A Product Liability claim could arise from:",
    items4: [
      "A fault in the product’s creation or production: As an example, when a power adapter’s plastic shell is not sealed tightly enough, electrical wires are exposed and can shock users.",
      "A defect in the product’s design: For example, clothing made with a chemically dangerous dye can make people sick.",
      "Defective warnings, instructions or labelling of the product: For example, a specialized work machine may be sold without clear usage instructions or a notice about the risks involved in improper use.",
    ],
  },
  cyber: {
    overview: [
      "Cybersecurity insurance( cyber insurance) is a product that allows businesses to reduce the threat of cyber crime scheme like cyber attacks and data breaches.",
      "It protects institutions from the cost of internet- grounded pitfalls affecting IT structure, information governance and policy, which frequently aren’t covered by marketable liability programs and other insurance products.",
      "The functioning of cyber insurance content is analogous to that of business insurance against natural disasters and physical hazards. It protects against any losses an organization might sustain as a result of a cyberattack.",
      "Insurance for cybersecurity generally includes first- party content of losses incurred through data destruction, hacking, data extortion, and data theft. It also helps them cover any costs related to the remediation process, similar as paying for the investigation, crisis communication, legal services, and refunds to clients.",
    ],
    title: "What does Cyber Liability insurance typically cover?",
    items: [
      "Cyber liability insurance is a type of business insurance that protects",
      "your business against the financial and legal consequences of cybercrime incidents. In general, your coverage might pay for expenditures and restorations associated with the following:",
    ],
    items_button: [
      "Information about clients may have been lost or stolen in data breaches",
      "Network security breaches",
      "Business interruption costs due to cyber incidents",
      "Forensic examination to determine the origin or scope of a breach",
      "Data recovery costs",
      "Cyber extortion (e.g., ransomware attacks)",
      "Crisis management costs (reputation protection after a cyber event)",
    ],
    sub_title:
      "Legal fees and loss incurred from a third party’s claim that your company violated data or network security, including fines and penalties.",
    title1: "What is typically NOT covered?",
    items1_button: [
      "Bodily injury and property damage",
      "Prior known facts or circumstances Intentional or fraudulent acts",
      "Damage to computer hardware",
      "Upgrading of an application, system, or network",
      "Outage of power, utilities, satellites, or tele services",
    ],
    sub_title1:
      "Take a moment to think about this. This may be the first time you’ve thought about how losing your website could affect your business. Could your business survive the harm to its brand and the financial losses caused by a data breach?",
    title2: "Just consider the following:",
    items2: [
      "How would your business suffer if a hacker gained access to all of your files and demanded an enormous payment be released?",
      "Is it possible for a cyberattack to completely stop your business’s operations?",
      "Is it possible that an unauthorized email directing funds or disclosing personal information could target you or your employees?",
      "How might a data breach affect your business?",
      "The amount and sensitive nature of the client information you keep on file, as well as the security measures in place to safeguard it",
    ],
    title3: "Who benefits from this type of Insurance:",
    items3: [
      "Any business that trades via a website or online platform",
      "Any business that uses email",
      "Any business that handles client information",
      "Retailers who use EFTPOS machines",
      "Companies reliant on IT systems to conduct business.",
      "Examples of professions in this field include accountants, consultants, real estate agents, retailers, restaurants, and manufacturers.",
    ],
  },
  professional: {
    overview: [
      "Professional indemnity insurance shields you and your business from allegations of carelessness or moral failure resulting from actions, mistakes, or omissions made while providing professional services.",
      "Professional Indemnity Insurance empowers you to pursue legal routes to clear your name and defend your esteem– with the backing of a legal and insurance team.",
      "Professional indemnity insurance is required by many trade associations as part of their regulatory frameworks. Even though having PI insurance is not required, failing to do so could result in thousands of pounds in lost income due to the time spent defending against any allegations, as well as thousands of pounds in legal expenses and compensation payments.",
    ],
    title: "Professional Indemnity claims can arise from simple things like :",
    items_button: [
      "Giving incorrect advice",
      "Miscalculation",
      "Incorrect diagnosis or treatment",
      "An act, omission or breach of duty",
      "Engaging in misleading or deceptive conduct",
      "Loss of documentation",
      "Inadvertently defaming someone",
      "Failing to meet a deadline",
      "Not meeting your clients’ expectations",
    ],
    title1: "What’s typically included?*",
    sub_title1_top:
      "The professional indemnity policy you choose may or may not protect you from damages resulting from unintentional or deliberate professional misconduct, including but not limited to the following:",
    items1: [
      "Providing your client with misleading or negligent advice",
      "Breaching your professional duty",
      "Confidentiality and other privacy breaches",
      "Defamation, libel or slander",
      "Loss of or damage to documents",
      "Infringement of intellectual property",
      "Payment of compensation as a result of a claim, including but not limited to Court awarded damages",
      "An award of legal costs claimed against you",
      "Reasonable legal costs expended in defending or answering the claim Claim investigation costs",
      "Disciplinary proceeding costs",
      "Depending on the type of Professional Indemnity insurance policy you have, it may extend to provide cover for public relation costs to help protect your business’ reputation",
    ],
    sub_title1_end:
      "Your professional indemnity insurance coverage for allied health professionals also covers claims for disease or bodily injury resulting from the professional services covered by the policy.",
    title2: "What is typically not covered?*",
    items2: [
      "Intentional damage or misconduct",
      "Contractual liabilities",
      "Professional fees refunds",
      "Recognized circumstances and claims that might have occurred before the insurance term",
      "Acts of fraud and dishonesty",
      "Property damage and accidental injuries (public liability insurance would normally cover these types of claims)",
    ],
    title3: "How Much Cover Should I have ?",
    items3:
      "You can select policies with different levels of coverage from our website’s leading insurers by using Primus Agents.",
    title4:
      "When estimating the potential amount of coverage, take into consideration:",
    items4: [
      "What are the possible risks (what could go wrong), and what might the cost of a claim be in the event that something goes wrong?",
      "The importance of the projects you complete or the worth of your contributions",
      "Any legal requirements specific to your line of work",
      "Any obligations imposed by organizations or professional bodies that you are a member of. Recall that you should review your risk exposure as your company expands and raise your coverage as necessary.",
    ],
  },
};

export const service_conveyancing = {
  title: "CONVEYANCING",
  sub_title: "Made Easy",
  card: [
    {
      id: 1,
      title: "SIMPLICITY",
      description:
        "Choose your package, provide your information and check your inbox. It’s that simple.",
      image: require("../assets/services-images/simplicity.png"),
    },
    {
      id: 2,
      title: "ON-TIME GUARANTEE",
      description:
        "If your settlement is delayed due to Primus conveyancing, you don’t pay anything.",
      image: require("../assets/services-images/timer.png"),
    },
    {
      id: 3,
      title: "COST EFFECTIVE",
      description:
        "Don’t pay more than you have to for conveyancing. Primus conveyancing does more for less.",
      image: require("../assets/services-images/cost-effective.png"),
    },
  ],
  para1:
    "Primus Conveyancing is your one stop shop for all of your conveyancing needs. Whether you are buying or selling, our services will make sure that you are covered throughout the process and our on-time guarantee will ensure we do not delay the settlement process.",
  para2:
    "It is very important to be aware of what services your conveyancer is performing. Although some conveyancers may seem cheaper, you need to be careful because they may not be providing all of the required services for that quote. Complete the form below to find out more about Primus Conveyancing’s services and pricing.",
};
